// frontend/src/components/grid/ChipSlot.jsx
//
// A grid cell's content that shows one of a closed set — a chip, or a button's
// label (PurchaseOrderRowActions' next step) — and is as wide as the widest
// one its column can show. AG Grid sizes a column from the cells it has rendered
// (`getPreferredWidthForColumn` clones the on-screen cells and reads their
// width), so a column measured on a screen of short chips would clip a longer
// one scrolled in later — and a hand-picked width clips in another language.
// The alternatives sit invisible in the same grid area as the shown chip, not
// beside it, and are hidden from assistive tech. Every item is centred in that
// area: an item that holds a line of text (a hidden alternative's wrapper, a
// `<span>` of plain text) is as tall as the cell's line-height, so a chip left
// at the area's top would sit high in the row.
//
// `shown` is an element, never bare text: the grid wraps a bare text run in an
// anonymous item that no selector can place, so it would auto-place into a
// second row below the alternatives.
//
// A column whose cells render through ChipSlot is measured like any other
// (no `width`, no `suppressAutoSize`).

import { isValidElement } from 'react';
import { Box } from '@mui/material';

const SLOT_SX = { display: 'inline-grid', justifyItems: 'center', alignItems: 'center', '& > *': { gridArea: '1 / 1' } };

export default function ChipSlot({ shown, alternatives }) {
  if (!isValidElement(shown)) throw new Error('ChipSlot: `shown` must be an element — wrap text in a <span>');
  return (
    <Box component="span" sx={SLOT_SX}>
      {shown}
      {alternatives.map((alternative, i) => (
        <Box key={i} component="span" aria-hidden="true" sx={{ visibility: 'hidden' }}>{alternative}</Box>
      ))}
    </Box>
  );
}
